import React, { MouseEvent } from "react"
//import styles from "./CookieConsentLink.module.scss"

declare global {
  interface CookiebotConsents {
    given: boolean
    preferences: boolean
    statistics: boolean
    marketing: boolean
    method?: null | "explicit" | "implied"
  }

  interface Window {
    Cookiebot?: {
      renew: () => void
      consent: CookiebotConsents
    }
    ldanalytics
  }
}

type CookieConsentLinkProps = {
  children: React.ReactNode
}

/**
 * Link like element that triggers a Cookiebot event when clicked.
 * For now triggers only "reset" event.
 */
const CookieConsentLink = (props: CookieConsentLinkProps) => {
  function onResetLinkClick(_e: MouseEvent<HTMLAnchorElement>) {
    if (window.Cookiebot !== undefined) {
      window.Cookiebot.renew()
    }
  }

  return (
    <a role="button" href="#cookiebot-reset" onClick={onResetLinkClick}>
      {props.children}
    </a>
  )
}

export default CookieConsentLink
